module.exports = __webpack_public_path__ + "img/_DSC1076.3131e9ff.png";